"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var Category_1 = require("../Category");
var Discount_1 = require("../Discount");
var Payments_1 = require("../Payments");
var CartDiscountBaseLine = /** @class */ (function () {
    function CartDiscountBaseLine(cartDiscountLine, mappedCategories) {
        var _this = this;
        this.type = Payments_1.PaymentLineType.DISCOUNT;
        this.shouldBeExcluded = function (productId, categoryId) {
            /**
             * Examine whether a cart discount is subject to product and category IDs to be excluded
             */
            if (productId === null)
                return true; // i.e. discount line
            if (categoryId && _this.systemFeesCategoryIds.includes(categoryId)) {
                return true;
            }
            var shouldExcludeProductId = _this.excludeProductIds.includes(productId);
            var shouldExcludeCategoryId = categoryId === null
                ? false
                : _this.excludeCategoryIds.includes(categoryId);
            return shouldExcludeProductId || shouldExcludeCategoryId;
        };
        this.shouldBeTargeted = function (productId, categoryId) {
            /**
             * This examines whether `productId` or `categoryId` are specifically targeted by a cart discount
             */
            if (productId === null)
                return false; // i.e. discount line
            var shouldExcludeProductId = _this.excludeProductIds.includes(productId);
            if (shouldExcludeProductId) {
                return false;
            }
            var productIdTargeted = _this.targetedProductIds.includes(productId);
            var categoryIdTargeted = categoryId === null
                ? false
                : _this.targetedCategoryIds.includes(categoryId);
            var parentCategoryIdTargeted = _this.targetedCategoryIds.find(function (targetedCategoryId) {
                var parentCategory = _this.mappedCategories.get(targetedCategoryId);
                if (!parentCategory)
                    return false;
                var childCategoryFound = parentCategory.childCategories.find(function (childCategory) { return childCategory.id === categoryId && !_this.excludeCategoryIds.includes(childCategory.id); });
                if (childCategoryFound)
                    return true;
                return false;
            });
            return productIdTargeted || categoryIdTargeted || !!parentCategoryIdTargeted;
        };
        this.referenceDiscount = cartDiscountLine.referenceDiscount;
        this.mappedCategories = mappedCategories;
    }
    Object.defineProperty(CartDiscountBaseLine.prototype, "isTargetedCartDiscount", {
        get: function () {
            return this.targetedProductIds.length > 0 || this.targetedCategoryIds.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CartDiscountBaseLine.prototype, "loyaltyCost", {
        get: function () {
            return this.referenceDiscount ? this.referenceDiscount.loyaltyCost : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CartDiscountBaseLine.prototype, "excludeProductIds", {
        get: function () {
            return this.referenceDiscount === undefined
                ? []
                : this.referenceDiscount.products
                    .filter(function (pcl) { return pcl.type === 'exclude'; })
                    .map(function (pcl) { return pcl.id; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CartDiscountBaseLine.prototype, "excludeCategoryIds", {
        get: function () {
            var _this = this;
            if (this.referenceDiscount === undefined)
                return [];
            var explicitlyExcludedIds = this.referenceDiscount.categories.filter(function (pcl) { return pcl.type === 'exclude'; }).map(function (pcl) { return pcl.id; });
            var excludedCategoryIds = __spread(explicitlyExcludedIds);
            explicitlyExcludedIds.forEach(function (id) {
                var category = _this.mappedCategories.get(id);
                if (!category)
                    return;
                category.childCategories.forEach(function (child) {
                    excludedCategoryIds.push(child.id);
                });
            });
            return excludedCategoryIds;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CartDiscountBaseLine.prototype, "targetedProductIds", {
        get: function () {
            return this.referenceDiscount === undefined
                ? []
                : this.referenceDiscount.products
                    .filter(function (pcl) { return pcl.type === 'include'; })
                    .map(function (pcl) { return pcl.id; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CartDiscountBaseLine.prototype, "targetedCategoryIds", {
        get: function () {
            return this.referenceDiscount === undefined
                ? []
                : this.referenceDiscount.categories
                    .filter(function (pcl) { return pcl.type === 'include'; })
                    .map(function (pcl) { return pcl.id; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CartDiscountBaseLine.prototype, "discountMode", {
        // Currently we only support 3 discount modes
        get: function () {
            if ((this.excludeProductIds.length >= 0 || this.excludeCategoryIds.length >= 0) &&
                this.targetedProductIds.length === 0 &&
                this.targetedCategoryIds.length === 0) {
                return Discount_1.DiscountModes.ALL_PRODUCTS_AND_CATEGORIES;
            }
            if (this.excludeProductIds.length === 0 &&
                this.excludeCategoryIds.length === 0 &&
                this.targetedProductIds.length > 0 &&
                this.targetedCategoryIds.length === 0) {
                return Discount_1.DiscountModes.SPECIFIC_PRODUCTS;
            }
            if ((this.excludeProductIds.length >= 0 || this.excludeCategoryIds.length >= 0) &&
                this.targetedProductIds.length === 0 &&
                this.targetedCategoryIds.length > 0) {
                return Discount_1.DiscountModes.SPECIFIC_CATEGORIES;
            }
            return Discount_1.DiscountModes.NO_DISCOUNT; // This shouldn't happen
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CartDiscountBaseLine.prototype, "systemFeesCategoryIds", {
        get: function () {
            return Array.from(this.mappedCategories.values())
                .filter(function (category) { return category.categoryType === Category_1.CategoryType.SYSTEM_FEES; })
                .map(function (category) { return category.id; });
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        mobx_1.computed
    ], CartDiscountBaseLine.prototype, "isTargetedCartDiscount", null);
    __decorate([
        mobx_1.computed
    ], CartDiscountBaseLine.prototype, "loyaltyCost", null);
    __decorate([
        mobx_1.computed
    ], CartDiscountBaseLine.prototype, "excludeProductIds", null);
    __decorate([
        mobx_1.computed
    ], CartDiscountBaseLine.prototype, "excludeCategoryIds", null);
    __decorate([
        mobx_1.computed
    ], CartDiscountBaseLine.prototype, "targetedProductIds", null);
    __decorate([
        mobx_1.computed
    ], CartDiscountBaseLine.prototype, "targetedCategoryIds", null);
    __decorate([
        mobx_1.computed
    ], CartDiscountBaseLine.prototype, "discountMode", null);
    __decorate([
        mobx_1.computed
    ], CartDiscountBaseLine.prototype, "systemFeesCategoryIds", null);
    return CartDiscountBaseLine;
}());
exports.CartDiscountBaseLine = CartDiscountBaseLine;
//# sourceMappingURL=CartDiscountBaseLine.js.map